import { createSlice } from '@reduxjs/toolkit';
import { LANGUAGE_CODES } from 'constants/signUp';

const initialState = {
	formValues: {
		signupToken: '',
		onboardingLanguage: LANGUAGE_CODES.english,
		email: '',
		firstName: '',
		lastName: '',
		phone: '',
		listedInAuctionAccessAccount: '',
		listedInMeetTheStaff: '',
		usesEmailBusinessDomain: '',
		userHasAuctionAccessAccount: '',
		dealershipName: '',
		dealershipAddress: '',
		dealershipAddress2: '',
		city: '',
		state: '',
		zip: '',
		dealershipPhone: '',
		dealershipPhoneType: '',
		dealershipType: '',
		dealerType: '',
		dealershipHasAuctionAccessAccount: '',
		auctionAccessId: '',
		replaceDeactivatedDealership: '',
		letterOfAuthorizationEmail: '',
	},
};

export const signUpSlice = createSlice({
	name: 'signUp',
	initialState: initialState,
	reducers: {
		setFormValues: (state, action) => {
			const newFormValues = action.payload;
			state.formValues = { ...state.formValues, ...newFormValues };
		},
	},
});

export const { setFormValues } = signUpSlice.actions;

export default signUpSlice.reducer;
